import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import NewUser from './NewUser';
import UpdateUser from './UpdateUser';


function UserManage() {

  const [value, setValue] = React.useState('new');

  // const handleChange = (event: React.SyntheticEvent, newValue: string) => {
  //   setValue(newValue);
  // };
  
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };


  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="User Management"
        variant="scrollable"
      >
        <Tab
          value="new"
          label="New User Creation"
          wrapped
           className="windows-tab"
        />
        <Tab value="update" label="Update User"   className="windows-tab"/>
        <Tab value="search" label="Search User"  className="windows-tab"/>
      </Tabs>

      {/* Conditional rendering of content based on selected tab */}
      <Box sx={{ padding: 2 }}>
        {value === 'new' && (

<>
          <div className="windows-header">
  <h2>New User Creation</h2>
</div>
<div className="content">
  <NewUser />
</div>
</>  

          
        )}
        {value === 'update' && (
<>
<div className="windows-header">
<h2>Update User</h2>
</div>
<div className="content">
<UpdateUser />
</div>
</>  


         
        )}
        {value === 'search' && (
         

<>
<div className="windows-header">
<h2>Content for Search User Tab</h2>
</div>
<div className="content">
<Button variant="text" color="error">Button for Search User</Button>
</div>
</>  



             )}
      </Box>
    </Box>
  );
}

export default UserManage;
